'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keyMirror = require('react-utils/keyMirror');

var _keyMirror2 = _interopRequireDefault(_keyMirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValidateActionTypes = (0, _keyMirror2.default)({
  FIRST_NAME_VALIDATED: null,
  LAST_NAME_VALIDATED: null,
  EMAIL_VALIDATED: null,
  PASSWORD_VALIDATED: null,
  DOMAIN_VALIDATED: null,
  VALIDATE_SUCCEEDED: null,
  VALIDATE_ATTEMPTED: null,
  VALIDATE_FAILED: null,
  EMAIL_DOMAIN_FORM_SUBMITTED: null
});

exports.default = ValidateActionTypes;
module.exports = exports['default'];